import * as React from 'react';

import {formatNumberWithMetrixPrefix} from 'nutshell-core/utils/format-number-with-metric-prefix';

// @ts-expect-error - imported from .js/.jsx file
import {AudienceIcon} from '../icon/svg/audience-icon';
// @ts-expect-error - imported from .js/.jsx file
import {IndustryIcon} from '../icon/svg/industry-icon';
import {LocationPinIcon} from '../icon/svg/location-pin-icon';
// @ts-expect-error - imported from .js/.jsx file
import {RevenueIcon} from '../icon/svg/revenue-icon';
import {StackLegacy} from '../layout/stack/stack-legacy';

import {DetailRow} from './detail-row';

export type Account = {
    name: string;
    websiteUrl: string;
    industry: string;
    size: Range;
    location: string;
    revenue: Range;
};

type Range = {
    gte: number | null | undefined;
    lte: number | null | undefined;
};

type Props = {
    account: Account;
};

export function AccountDetails(props: Props) {
    const {account} = props;

    return (
        <StackLegacy spacing={6}>
            <DetailRow
                value={account.location}
                fallbackText='No location info'
                IconComponent={LocationPinIcon}
            />
            <DetailRow
                value={account.industry}
                fallbackText='No industry info'
                IconComponent={IndustryIcon}
            />
            <StackLegacy spacing={16} isHorizontal={true}>
                <DetailRow
                    value={formatRange(account.size, (item) => item.toLocaleString())}
                    fallbackText='No size info'
                    IconComponent={AudienceIcon}
                />
                <DetailRow
                    value={formatRange(account.revenue, (item) => {
                        const {prefix, formatted, suffix} = formatNumberWithMetrixPrefix(item, '$');

                        return `${prefix}${formatted}${suffix}`;
                    })}
                    fallbackText='No revenue info'
                    IconComponent={RevenueIcon}
                />
            </StackLegacy>
        </StackLegacy>
    );
}

function formatRange(
    {gte, lte}: Range,
    formatItem: (item: number) => string
): string | null | undefined {
    const gteString = typeof gte === 'number' ? formatItem(gte) : null;
    const lteString = typeof lte === 'number' ? formatItem(lte) : null;

    if (lteString) {
        const gteStringOrZero = gteString ? gteString : formatItem(0);

        return `${gteStringOrZero}-${lteString}`;
    }

    if (gteString) {
        return `${gteString}+`;
    }

    return null;
}
